import * as STRINGS from '../strings'
export default {
  [STRINGS.SAFEWALK_ACTIVATED_TEXT]: 'Du kommer att få aviseringar när din timer är på väg att löpa ut. Varningar kommer att skickas om den löper ut.',
  [STRINGS.SAFEWALK_ALARM_ACTIVE_BODY_TEXT]: 'Din Safe walk incheckningstimer har gått ut. Din organisation och/eller valda kontakter har blivit varnade.\nOm du är säker, avbryt det aktiva larmet nedan.',
  [STRINGS.SAFEWALK_ALARM_CANCELLED_BODY_TEXT]: 'Din organisation och/eller valda kontakter kommer att meddelas om att ditt Safe Walk-larm har avbrutits. Eftersom de kanske redan har blivit larmade kan du få samtal eller textmeddelanden för att bekräfta din säkerhet.',
  [STRINGS.SAFEWALK_ALARM_ENDED_BODY_TEXT]: 'Din organisation och/eller valda kontakter kommer att meddelas om att din Safe Walk har avslutats säkert.',
  [STRINGS.SAFEWALK_ALARM_WARNING_BODY_TEXT]: 'Varningar kommer att skickas med din plats och tillgängliga kontaktuppgifter om din timer går ut.',
  [STRINGS.SAFEWALK_BUTTON_ALARM_ACTIVE_TEXT]: 'Safe walk larm utlöst',
  [STRINGS.SAFEWALK_BUTTON_BEGIN_TEXT]: 'Starta en Safe walk',
  [STRINGS.SAFEWALK_BUTTON_WALK_ACTIVE_TEXT]: 'Safe walk aktiv för',
  [STRINGS.SAFEWALK_BUTTON_WARNING_TEXT]: 'Safe walk aktiv för',
  [STRINGS.SAFEWALK_CONTACTS_DESCRIPTION]: 'Varningar kommer att skickas med din plats och tillgängliga kontaktuppgifter om din timer går ut.',
  [STRINGS.SAFEWALK_CONTACTS_DISCLAIMER]: 'Omnilert kommer bara att använda dina kontakters SMS-nummer för att varna dem under din Safe Walk.',
  [STRINGS.SAFEWALK_CONTACTS_FORM_DESCRIPTION]: 'Valfritt: Ange kontakternas SMS-nummer nedan för att lägga till dem i dina Safe Walk-aviseringar.',
  [STRINGS.SAFEWALK_CUSTOM_DURATION_TEXT]: 'Ställ in din egen timertid.',
  [STRINGS.SAFEWALK_INSTALL_BANNER_BODY]: 'Ladda ner appen för bättre platsnoggrannhet. Om du fortsätter, håll webbläsaren öppen och telefonen olåst för att dela din plats om din timer går ut.',
  [STRINGS.SAFEWALK_INSTALL_BANNER_HEADER]: 'Förbättra nödlägesnoggrannheten.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_CONTACTS_FORM_DESCRIPTION]: 'För att fortsätta, ange SMS-nummer för att meddela din Safe Walk. Om du utlöser ett larm kommer din plats också att delas.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_INFO_ONE_TEXT]: 'Din organisation har gjort det möjligt för dig att använda Safe walk utanför campus eller utanför öppettider. För att starta en promenad måste du lägga till kontakter för att meddela.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_INFO_TWO_TEXT]: 'För att fortsätta, välj upp till (3) kontakter för att meddela din Safe Walk och plats om du skulle utlösa ett larm.',
  [STRINGS.SAFEWALK_OFF_CAMPUS_TEXT]: 'Din organisation låter dig använda Safe walk off campus genom att lägga till upp till (3) kontakter att meddela.',
  [STRINGS.SAFEWALK_ON_CAMPUS_QUESTION_TEXT]: 'Är du på campus?',
  [STRINGS.SAFEWALK_ON_CAMPUS_TEXT]: 'Din organisation kan få ett meddelande när du börjar din promenad och om du utlöser ett larm.',
  [STRINGS.SAFEWALK_SMS_DESCRIPTION]: 'Du kommer att få ett SMS och/eller push-meddelande när din timer är på väg att löpa ut.',
  [STRINGS.SAFEWALK_TIMER_EXPIRY_INFO]: 'Varningar kommer att skickas med din plats och tillgängliga kontaktuppgifter om din timer går ut.',

  [STRINGS.BUTTON_DOWNLOAD]: 'Ladda ner',
  [STRINGS.BUTTON_OPEN_APP]: 'Öppna app',
  [STRINGS.BUTTON_SAFEWALK_ACTIVATE]: 'Starta en Safe walk',
  [STRINGS.BUTTON_SAFEWALK_ADD_CONTACTS]: 'Lägg till kontakter för att meddela',
  [STRINGS.BUTTON_SAFEWALK_CANCEL_ALARM]: 'Avbryt larm',
  [STRINGS.BUTTON_SAFEWALK_CHECK_IN_TIMER_SET]: 'Incheckning om {{duration}} minuter',
  [STRINGS.BUTTON_SAFEWALK_CHECKIN_TIMER]: 'Ställ in incheckningstimer för Safe walk',
  [STRINGS.BUTTON_SAFEWALK_END_WALK]: 'Avsluta',
  [STRINGS.BUTTON_SAFEWALK_NEW_WALK]: 'Starta en ny Safe Walk',
  [STRINGS.BUTTON_SAFEWALK_TRIGGER_ALARM]: 'Larm',
  [STRINGS.BUTTON_CANCEL]: 'Avbryt',
  [STRINGS.BUTTON_CLOSE]: 'Stänga',
  [STRINGS.BUTTON_CONTINUE]: 'Fortsätt',
  [STRINGS.BUTTON_DIAL_911_SHORT]: 'Ring 112',
  [STRINGS.BUTTON_DIAL_911]: 'Ring 112 vid en nödsituation',
  [STRINGS.BUTTON_EMERGENCY]: 'Håll intryckt för att få hjälp',
  [STRINGS.BUTTON_OK]: 'OK',
  [STRINGS.BUTTON_SEND]: 'Skicka',
  [STRINGS.BUTTON_SUBMIT_SILENT_ALERT]: 'Skicka tyst varning',
  [STRINGS.BUTTON_SUBMIT]: 'Skicka',
  [STRINGS.BUTTON_TIP_CATEGORY]: 'Välj tipskategori',
  [STRINGS.BUTTON_TIP_LOCATION]: 'Tips plats',
  [STRINGS.COMMON_CONFIRM]: 'Yes',
  [STRINGS.COMMON_DENY]: 'No',
  [STRINGS.SCREEN_TITLE_TIP_LOCATION]: 'Tippar plats',
  [STRINGS.EMPTY_STATE_RESOURCES]: 'Inga resurser hittades.',
  [STRINGS.ERROR_ACCOUNT_SETUP]:
    'Det finns ett problem med din kontoinställning. Kontakta en administratör.',
  [STRINGS.ERROR_CONFIG_UNDEFINED]:
    'Det finns ett problem med din installation. Kontakta en administratör för att konfigurera din push-endpoint.',
  [STRINGS.ERROR_FIREBASE]:
    'Det finns problem med att kommunicera med vårt system. Vänligen försök din förfrågan igen.',
  [STRINGS.ERROR_TITLE]: 'Ett fel uppstod',
  [STRINGS.ERROR_VALIDATION_401]:
    'Valideringskoden som du angav är ogiltig. Se till att du har angett det korrekt',
    
  [STRINGS.INDICATOR_NEW_MESSAGES]: 'Nya meddelanden',
  [STRINGS.INDICATOR_SCROLL]: 'Olästa meddelanden',
  [STRINGS.LABEL_ACCOUNT]: 'konto',
  [STRINGS.LABEL_TIP_CATEGORY]: 'Välj tipskategori',
  [STRINGS.LABEL_TIP_LOCATION]: 'Skicka aktuell plats',
  [STRINGS.LABEL_TIP_PRIVATE]: 'Göra privat',
  [STRINGS.LAUNCH]: 'Lansera',
  [STRINGS.LAUNCH_SCENARIO]: 'Lanseringsscenario',
 
  [STRINGS.MESSAGE_LOCATION]: 'Meddelandeplats',
  [STRINGS.MESSAGE_LOCATION_ERROR_TOAST]:
    'Your organization has requested your location to assist in the current situation. Your response or status will be sent without location unless you re-enable location access.',
  [STRINGS.MESSAGE_TITLE_TIP]: 'tipsrapport', // TODO: Fix me
  [STRINGS.MESSAGE_TITLE_TIP_ANONYMOUS]: 'Anonym tips {{category}}',
  
  [STRINGS.MODAL_BODY_LOCATION_PERMISSION]:
    'Platsbehörigheter är inte aktiverade. Vänligen aktivera plats för att hjälpa våra agenter hjälpa dig bättre. Viktiga funktioner kommer inte att vara tillgängliga om du avvisar.',
  [STRINGS.MODAL_BODY_LOCATION_PERMISSION_DENIED]:
    'Platsrättigheter nekades. Aktivera plats genom att gå till dina enhetsinställningar. När du har aktiverat plats, försök igen.',
  [STRINGS.MODAL_BODY_TIP_TITLE]: 'Ditt tips har skickats. 👍',
  [STRINGS.MODAL_BODY_TIP_TITLE_ANON]: 'Ditt tips har anmälts anonymt.',
  [STRINGS.MODAL_BODY_TIP_BODY]: 'Tack för din rapport, vi kan inte direkt svara på tiprapporter.',
  [STRINGS.MODAL_BODY_TIP_EMERGENCY]:
    'If this is an emergency, please dial local emergency services.',
  [STRINGS.MODAL_TITLE_LOCATION_PERMISSION]: 'Aktivera platstjänster',
  [STRINGS.MODAL_TITLE_LOCATION_PERMISSION_DENIED]: 'Lokationstjänster inaktiverade',
  [STRINGS.NO_RESPONSE]: 'Inget svar',
  [STRINGS.NOT_AUTH_TITLE]: 'Du har tyvärr inte behörighet att komma åt den här sidan.',
  [STRINGS.NOT_AUTH_SUBTITLE]: 'Kontakta din systemadministratör om du tror att du har fått det här meddelandet av misstag.',
  [STRINGS.NOT_FOUND_TITLE]: 'Den här sidan är inte tillgänglig',
  [STRINGS.NOT_FOUND_SUBTITLE]: 'Länken du har kan vara trasig, vi kan inte hitta den resurs du letar efter.',
  
  [STRINGS.PRIORITY_HEADER_GUN]: 'Pistol upptäckt',
  [STRINGS.PRIORITY_HEADER_PANIC]: 'Varning för panikknapp',
  [STRINGS.PRIORITY_HEADER_TIP]: 'Varning för Tip',
  [STRINGS.PRIORITY_FALSE_POSITIVE]: 'Falskt positivt',
  [STRINGS.PRIORITY_MENU_RESOLVE]: 'Lös problemet',
  [STRINGS.PRIORITY_BADGE_RESOLVED]: 'löst',
  [STRINGS.PLACEHOLDER_MESSAGE]: 'Skriv ditt meddelande',
  [STRINGS.PLACEHOLDER_RESPONSE]: 'Ange svar här',
  [STRINGS.PLACEHOLDER_RESOURCES_FILTER]: 'Personlig åtkomstkod',
  [STRINGS.PLACEHOLDER_TIP]: 'Ange tips här',
  [STRINGS.PUSH_REG_TEXT]: 'Omnilert Mobile App är utformad för mobil användning. Öppna den här registreringslänken från din mobila enhet. ',
  [STRINGS.SCREEN_TITLE_TIP]: 'Skicka tips',
  [STRINGS.SCREEN_TITLE_TIP_CATEGORY]: 'Välj Tipskategori',
  [STRINGS.SCREEN_TITLE_TIP_ATTACHMENT]: 'Attachment',
  [STRINGS.SCREEN_TITLE_TIP_LOCATION]: 'Tips plats',
  [STRINGS.TAB_TITLE_MESSAGES]: 'Meddelanden',
  [STRINGS.TAB_TITLE_RESOURCES]: 'Resurser',
  [STRINGS.TAB_TITLE_SAFEWALK]: 'Safe walk',
  [STRINGS.TAB_TITLE_TIPS]: 'Tips',
 
  [STRINGS.TIP_CATEGORY_DEFAULT]: 'Ingen kategori har valts',
  [STRINGS.TIP_LOCATION_ERROR_TOAST]:
    'To share the location of your tip with Your organization, please re-enable location access.',
  [STRINGS.TIP_SCREEN_EMERGENCY_LINE_ONE]: 'If this is a safety emergency',
  [STRINGS.TIP_SCREEN_EMERGENCY_LINE_TWO]: 'Dial local emergency services',
  [STRINGS.USER]: 'Användare',
  [STRINGS.USERS]: 'Användare',
  
  [STRINGS.USER_ERROR_DEFAULT]: 'Ett okänt fel uppstod.',
  [STRINGS.USER_ERROR_MAX_UPLOADS]: 'Välj högst tre (3) filer att ladda upp.',
  [STRINGS.USER_ERROR_1001]: 'Din enhet togs inte bort från systemet. Kontakta en administratör.',
  [STRINGS.USER_ERROR_1002]: 'Din enhet togs inte bort från systemet. Kontakta en administratör.',
  [STRINGS.USER_ERROR_2001]:
    'Det gick inte att skicka ditt meddelande till vår server. Vänligen försök igen senare.',
  [STRINGS.USER_ERROR_3001]:
    'Det gick inte att registrera din enhet för att ta emot push-aviseringar. Kontakta en administratör.',
  [STRINGS.USER_ERROR_3002]:
    'Det gick inte att registrera din enhet för att ta emot push-aviseringar. Kontakta en administratör.',
  [STRINGS.USER_ERROR_4001]:
    'Det uppstod ett problem med att registrera din enhet i systemet. Kontakta en administratör.',
  [STRINGS.USER_ERROR_4002]: 'En valideringskod krävs. Ange en valideringskod och försök igen.',
  [STRINGS.USER_ERROR_4003]:
    'Din valideringskod är kopplad till ett konto som inte är korrekt konfigurerat. Kontakta en administratör.',
  [STRINGS.USER_ERROR_4004]:
    'Din valideringskod är inte registrerad i vårt system. Se till att det är korrekt.',
  [STRINGS.USER_ERROR_4005]:
    'Det finns ett problem med din valideringskod. Kontakta en administratör.',
  [STRINGS.USER_ERROR_4006]:
    'Din valideringskod har inte rätt längd. Se till att koden är 10 tecken.',
  [STRINGS.USER_ERROR_5001]:
    'Det uppstod ett problem med att markera ett meddelande som läst. Vänligen försök igen senare.'
}
